<template>
  <div class="lv-cascader-body">
    <input type="text" placeholder="请选择" readonly="readonly" @focus="show=true" v-model="chooseStr">
    <div class="lv-mask" @click.stop="show=false" v-if="show">
      <div class="lv-tree-body" @click.stop="">
        <div class="lv-tree-header">
          <div class="lv-tree-container">
            <div class="title">
              <slot name="title">请选择</slot>
            </div>
            <img src="/img/ui/law/close.png" @click.stop="cancel()">
          </div>
        </div>
        <div class="lv-tree-main">
          <lv-tree
            :treeData="treeArray"
            :chooseList="chooseList"
          >
          </lv-tree>
        </div>
        <div class="lv-tree-footer">
          <button class="primary" @click.stop="submit()">确定</button>
          <button @click.stop="cancel()">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tree from './tree'
import { listToTree }from '@/plugins'

export default {
  components: {
    'lv-tree': Tree
  },
  props: {
    treeData: {
      type: Array,
      required: true,
      default: () => {}
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: false,
      isTree: true,
      chooseList: [],
      chooseStr: ''
    }
  },
  computed: {
    treeArray () {
      return  listToTree(this.treeData.filter(item => {
        return item.name.search(/(空)/g) === -1 && item.name.search(/(移动)/g) === -1
      }), undefined, undefined, true).reverse()
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (val) {
          this.treeData.forEach(item => {
            if (item.id === val) {
              this.chooseStr = item.name
            }
          })
        } else {
          this.chooseStr = ''
        }
      }
    }
  },
  created () {
    this.$on('choose', this.chooseNode)
  },
  beforeDestroy () {
    this.$off('choose')
  },
  methods: {
    chooseNode (node) {
      if (!node.parentId) this.chooseList = []
      const value = Object.assign({}, { id: node['id'], title: node['name'] || node['title'] })
      if (this.beingArray(value)) {
        this.chooseList = this.chooseList.filter(item => item.id !== value.id)
      } else {
        let list = this.chooseList.concat([value])
        this.chooseList = list
      }
    },
    beingArray (opt) {
      return this.chooseList.find(item => item.id === opt.id)
    },
    submit () {
      if (!this.chooseList.length) {
        this.cancel()
        return
      }
      this.chooseStr = this.chooseList[this.chooseList.length - 1].title
      this.$emit('input', this.chooseList[this.chooseList.length - 1].id)
      this.show = false
    },
    cancel () {
      this.chooseList = []
      this.show = false
    }
  }
}
</script>
<style lang="stylus" scoped>
.lv-cascader-body
  width 100%
  font-size 0.22rem
  color #fff
  input
    height 0.7rem
    background rgba(255,255,255,0.2)
    border-radius 0.06rem
    border 0
    padding 0 0.05rem 0 0.1rem
    display block
    width 100%
  .lv-mask
    position fixed
    background rgba(0,0,0,0.5)
    left 0
    right 0
    top 0
    height 100vh
    display flex
    justify-content center
    align-items center
    z-index 10
    .lv-tree-body
      background #fff
      width 80vw
      border-radius 4px
      box-shadow 0 0 1px 1px #9b9b9b
      display flex
      flex-direction column
      overflow hidden
      padding 0.2rem 0.3rem
      .lv-tree-header
        flex-shrink 0
        display flex
        flex-direction column
        .lv-tree-container
          flex-shrink 0
          display flex
          align-items center
          justify-content space-between
          position relative
          .title
            color #333
          img
            width 24px
            height 24px
            position absolute
            top 0
            right 0
      .lv-tree-main
        flex auto
        border 1px solid #bfbfbf
        display flex
        overflow hidden
      .lv-tree-footer
        flex-shrink 0
        display flex
        align-items center
        padding 0.2rem 0
        button
          border-radius 4px
          width 2rem
          background #fff
          border 1px solid #dcdfe6
          color #333
          &:last-child
            margin-left 0.2rem
        .primary
          background #409eff
          color #fff
</style>
